import { render, staticRenderFns } from "./SlideItem.vue?vue&type=template&id=65cf4de8"
import script from "./SlideItem.vue?vue&type=script&lang=js"
export * from "./SlideItem.vue?vue&type=script&lang=js"
import style0 from "./SlideItem.vue?vue&type=style&index=0&id=65cf4de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports